import { render, staticRenderFns } from "./EditConsent.vue?vue&type=template&id=083125d6&"
import script from "./EditConsent.vue?vue&type=script&lang=js&"
export * from "./EditConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports